"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const huLocaleData = require("i18next-icu/locale-data/hu");
exports.default = huLocaleData;
//# sourceMappingURL=hu.js.map